module.exports = __webpack_public_path__ + "static/media/everlife-1.db13f3cb.svg";